import { Flex } from 'lib/components/styles/layout';
import React from 'react';
import {
  TwoLineVideoTitle,
  VideoThumbnail,
  VideoThumbnailSource,
} from './style';
import { useTheme } from 'styled-components/macro';
import { MdClose } from 'react-icons/md';
import { Button, Typography } from 'react-covideo-common';
import { IVideoDetails } from 'lib/api/quickVideo/types';

type SelectedVideoCardSmallProps = {
  video: IVideoDetails;
  onClear?: () => void;
};

export const SelectedVideoCardSmall = ({
  video,
  onClear,
}: SelectedVideoCardSmallProps) => {
  const theme = useTheme();
  return (
    <Flex
      flexDirection='row'
      gap='12px'
      width='100%'
      flexWrap='nowrap'
      alignItems='flex-start'
      justifyContent='space-between'
      borderRadius='4px'
      padding='8px'
      backgroundColor={theme.colors.neutral[10]}
      style={{ boxSizing: 'border-box' }}
    >
      <Flex gap='20px' flexDirection='row'>
        <VideoThumbnail>
          <VideoThumbnailSource src={video.thumbnail} alt={video.title} />
        </VideoThumbnail>
        <Flex
          flexWrap='nowrap'
          width='fit-content'
          justifyContent='space-between'
        >
          <TwoLineVideoTitle>{video.title}</TwoLineVideoTitle>
          <Typography variant='extra-small'>{video.recordDate}</Typography>
        </Flex>
      </Flex>

      {!!onClear && (
        <Button
          icon={<MdClose size={22} color={theme.colors.black[100]} />}
          variant='transparent'
          onClick={onClear}
          extendStyles={{
            container: {
              minWidth: 'unset',
              minHeight: 'unset',
              padding: 0,
            },
          }}
        />
      )}
    </Flex>
  );
};
